/**
 * Idioma de los componentes del theme
 * -----------------------------------------------------------------------------
 * El theme trae sus textos en español, pero son sustituibles: una app en
 * Symfony (o en cualquier otro sitio) puede inyectar los suyos ya traducidos.
 *
 *   <script src="/vendor/company-theme/js/company-theme.min.js"></script>
 *   <script>
 *     CompanyTheme.setLocale({
 *       dialog: { confirm: {{ 'dialog.confirm'|trans|json_encode|raw }} },
 *       notify: { close: {{ 'notify.close'|trans|json_encode|raw }} },
 *       datepicker: { monthsFull: {{ meses|json_encode|raw }} },
 *     });
 *   </script>
 *
 * Por qué hace falta: el traductor de Symfony trabaja en el servidor y no puede
 * alcanzar cadenas ya compiladas dentro del bundle JS. Con esto la app pasa las
 * traducciones al cargar, y el theme sigue siendo un paquete cerrado.
 *
 * CUÁNDO llamarlo: antes de que el theme se inicialice. Como `autoInit()` corre
 * en `DOMContentLoaded`, basta con ponerlo en un `<script>` después del theme;
 * ese código se ejecuta antes. Si se llama más tarde, hace falta `reinit()`.
 */

import {
  datepickerES,
  timepickerES,
  datetimepickerES,
  quickActionsES,
  monthPickerES,
  phoneES,
  dataViewES,
  cardES,
  workspaceES,
  notificationBellES,
  fileES,
  selectES,
  sidenavSearchES,
  notifyES,
  dialogES,
  formES,
} from './locale-es.js';

const REGISTRY = {
  datepicker: datepickerES,
  timepicker: timepickerES,
  datetimepicker: datetimepickerES,
  quickActions: quickActionsES,
  monthPicker: monthPickerES,
  phone: phoneES,
  dataView: dataViewES,
  card: cardES,
  workspace: workspaceES,
  notificationBell: notificationBellES,
  file: fileES,
  select: selectES,
  sidenavSearch: sidenavSearchES,
  notify: notifyES,
  dialog: dialogES,
  form: formES,
};

/**
 * Sustituye textos del theme. Solo hace falta enviar los que cambian.
 *
 * @param {Object} translations Objeto por componente: `{ dialog: { confirm: 'OK' } }`.
 * @returns {string[]} Claves que no existen, para detectar erratas.
 */
export function setLocale(translations = {}) {
  const unknown = [];

  Object.keys(translations).forEach((group) => {
    const target = REGISTRY[group];

    if (!target) {
      unknown.push(group);
      return;
    }

    // Se muta el objeto exportado en vez de reemplazarlo: los componentes leen
    // sus propiedades en el momento de usarlas, así que ven el cambio sin que
    // haya que re-importar nada.
    Object.assign(target, translations[group]);
  });

  return unknown;
}

/** Devuelve los textos actuales, útil para inspeccionar o para partir de ellos. */
export function getLocale() {
  const snapshot = {};
  Object.keys(REGISTRY).forEach((group) => {
    snapshot[group] = { ...REGISTRY[group] };
  });
  return snapshot;
}

export default setLocale;
